import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { BrandSearchPipe } from './brand-search.pipe';
import { CurrencyConvertPipe } from './currency-convert.pipe';
import { FilterBrandsPipe } from './filter-brands.pipe';
import { FilterByIdPipe } from './filter-by-id.pipe';
import { FilterPipe } from './filter.pipe';
import { NoSanitizePipePipe } from './no-sanitize-pipe.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafePipe } from './safe.pipe';
import { SplitbyHashPipe } from './splitby-hash.pipe';
import { TextTransformPipe } from './texttransform.pipe';
import { TranslatePipe } from './translate.pipe';
import { UnderScoreTransformPipe } from './under-score-transform-pipe.pipe';
import { FormatButtonTypePipe } from './format-button-type.pipe';
import { MentionHighlightPipe } from './mention-highlight.pipe';



@NgModule({
    imports: [
        CommonModule,
        MentionHighlightPipe
    ],
    declarations: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        SafePipe,
        SafeHtmlPipe,
        FilterPipe,
        CurrencyConvertPipe,
        TextTransformPipe,
        UnderScoreTransformPipe,
        TranslatePipe,
        SplitbyHashPipe,
        NoSanitizePipePipe,
        FormatButtonTypePipe,
    ],
    exports: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        SafePipe,
        SafeHtmlPipe,
        FilterPipe,
        CurrencyConvertPipe,
        TextTransformPipe,
        UnderScoreTransformPipe,
        TranslatePipe,
        SplitbyHashPipe,
        NoSanitizePipePipe,
        FormatButtonTypePipe,
        MentionHighlightPipe
        
    ], providers:[
        CurrencyPipe
    ]
})
export class PipesModule { }
